import { Component, Input, OnInit, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';

import LoginModel from '../../../../../models/user.model';
import { AppCommon } from '../../../../../providers/app-common';
import { SourcingNeedV2ViewModel } from '../../../../../models-views/sourcing-needs-v2.view.model';
import { StandardResponseModel } from '../../../../../models/project.model';

@Component({
  selector: 'app-sn-form-furniture-v2',
  templateUrl: './sn-form-furniture-v2.component.html',
  styleUrls: ['./sn-form-furniture-v2.component.scss'],
  standalone: false
})
export class SnFormFurnitureV2Component implements OnInit, OnChanges {
  @Input() eventId: number | null = null;
  @Input() data: any;
  @Output() closeModal = new EventEmitter<'success' | 'cancel'>();
  
  form!: FormGroup;
  isEdit: boolean = true;
  isView: boolean = false;
  existingData: any = null;

  constructor(private fb: FormBuilder, private vm: SourcingNeedV2ViewModel) {}

  ngOnInit(): void {
    this.vm.parentSnFormFurnitureV2Component = this;
    this.initForm();
    this.handleInputData();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data'] && !changes['data'].firstChange) {
      this.handleInputData();
    }
  }

  handleInputData(): void {

    if (this.data) {
      this.existingData = this.data;
      this.isView = false;
      this.isEdit = true;
      this.form.patchValue(this.mapApiToForm(this.data));
    } else {
      this.existingData = null;
      this.isView = false;
      this.isEdit = true;
      this.form.reset();
      this.form.enable();
    }
  }

  mapApiToForm(data: any): any {
    // Map API response to form fields
    if (data && typeof data === 'object' && !Array.isArray(data) && data.furniture_details) {
      return { furniture_details: data.furniture_details };
    }
    return { furniture_details: data || '' };
  }

  initForm(): void {
    this.form = this.fb.group({
      furniture_details: ['', Validators.required],
    });
  }

  onSave(): void {
    if (this.form.valid) {
      const payload = this.form.value;
      payload.id = this.eventId;
      
      const loggedInUser = AppCommon.getloggedInObject();
      const userId = loggedInUser?.user?.id;
      
      payload.modified_by = userId;
      payload.is_furniture_required = payload.furniture_details?.length > 0 ? true : false;
      
      this.vm.updateSourcingNeed(payload, 'sn-form-furniture-v2');
    }
  }

  furnitureAdded() {
    this.closeModal.emit('success');
    
    // Refresh parent component data
    if (this.eventId) {
      this.vm.getSouringNeedbyId(this.eventId, 'cet-sourcing-needs-v2');
    }
  }

  onEdit(): void {
    this.isEdit = true;
    this.isView = false;
    this.form.enable();
  }

  onCancel(): void {
    this.closeModal.emit('cancel');
  }
}